<template>
    <div>
      <modal-crear-editar
        :configuracion="configuracion_modal"
        @realizado="restablecer_inputs"
      ></modal-crear-editar>
      <tablita
        :cols="columnas"
        @cargar="cargar($event)"
        @cargar_url="cargar_url($event)"
        @nuevo="crear"
        @editar="editar($event)"
        :configuracion="configuracion_tabla"
        @refresh="refrescar($event)"
      ></tablita>
    </div>
  </template>
  <script>
  import { mapActions, mapState } from "vuex";
  import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
  import Tabla from "../../components/Tabla/Tabla";
  //import lenguaje from '../../config/es_datatable.json'
  export default {
    data: () => ({
      filter: "",
      columnas: [
        {
          key: "id",
          label: "ID",
          busqueda: "",
          tipo: "string",
          searchable: true,
          path: "id",
        },
        //{key:'nombre',label:'Nombre',busqueda:'',tipo:'string',searchable:true,path:'nombre'},
        {
          key: "fecha",
          label: "Fecha Carga",
          busqueda: "",
          tipo: "datetime",
          searchable: true,
          path: "fecha"
        },
        {
          key: "nro_folio",
          label: "N° Folio",
          busqueda: "",
          tipo: "string",
          searchable: true,
          path: "nro_folio",
        },
        
        {
          key: "transportes_id",
          label: "Patente",
          busqueda: "",
          tipo: "select-loadable",
          ruta: "/transportes",
          parametro: "patente",
          searchable: true,
          path: "patente",
          opciones: [],
          valor_opcion: "id",
          label_opcion: "patente",
        },
        {
          key: "kilometraje_odometro",
          label: "Km Odometro",
          busqueda: "",
          tipo: "number",
          searchable: false,
          path: "kilometraje_odometro",
        },
        {
          key: "kilometraje_manual",
          label: "Km Manual",
          busqueda: "",
          tipo: "number",
          searchable: false,
          path: "kilometraje_manual",
        },
        {
          key: "litros",
          label: "Litros",
          busqueda: "",
          tipo: "number",
          searchable: false,
          path: "litros",
        },
        {
          key: "km_recorrido",
          label: "Kms Recorridos",
          busqueda: "",
          tipo: "number",
          searchable: false,
          path: "km_recorrido",
        },
        {
          key: "rendimiento",
          label: "Rendimiento Km/Lts",
          busqueda: "",
          tipo: "string",
          searchable: false,
          path: "rendimiento",
        }
  
        //{key:'ciudades_id',label:'Comuna',busqueda:'',tipo:'select-loadable',ruta:'/comunas',parametro:'nombre',searchable:true,path:'comuna.nombre',opciones:[],valor_opcion:'id',label_opcion:'nombre'},
      ],
      botones: [
        // {
        //   label: "Editar",
        //   clase: "btn-warning",
        //   evento: "editar",
        //   icono: "fa fa-pen",
        // },
      ],
      lista: [],
      links: [],
    //   inputs: [
    //     {
    //       cols: 4,
    //       tipo: "texto",
    //       key: "nombre",
    //       valor: "",
    //       label: "Nombre (*)",
    //       disabled: true,
    //     },
    //     {
    //       cols: 4,
    //       tipo: "texto",
    //       key: "codigo_siep",
    //       valor: "",
    //       label: "Codigo SIEP",
    //       disabled: false,
    //     },
    //     {
    //       cols: 4,
    //       tipo: "select",
    //       key: "tipo_dependencias_id",
    //       valor: "",
    //       label: "Tipo Sucursal (*)",
    //       opciones: [],
    //       valor_opcion: "id",
    //       label_opcion: "nombre",
    //       disabled: false,
    //     },
    //     {
    //       cols: 4,
    //       tipo: "select-loadable",
    //       key: "empresas_id",
    //       valor: "",
    //       label: "Empresa",
    //       busqueda: "",
    //       ruta: "/empresas",
    //       parametro: "nombre",
    //       disabled: false,
    //       opciones: [],
    //       valor_opcion: "id",
    //       label_opcion: "nombre",
    //     },
  
    //     {
    //       cols: 4,
    //       tipo: "select-loadable",
    //       key: "dependencias_id",
    //       valor: "",
    //       label: "Sucursal Padre",
    //       busqueda: "",
    //       ruta: "/dependencias",
    //       parametro: "nombre",
    //       disabled: false,
    //       opciones: [],
    //       valor_opcion: "id",
    //       label_opcion: "id_nombre",
    //     },
    //     {
    //       cols: 4,
    //       tipo: "select",
    //       key: "ciudades_id",
    //       valor: "",
    //       label: "Comuna",
    //       opciones: [],
    //       valor_opcion: "id",
    //       label_opcion: "nombre",
    //       disabled: false,
    //     },
    //     {
    //       cols: 4,
    //       tipo: "texto",
    //       key: "telefono",
    //       valor: "",
    //       label: "Telefono",
    //       disabled: false,
    //     },
    //     {
    //       cols: 4,
    //       tipo: "texto",
    //       key: "email",
    //       valor: "",
    //       label: "Email",
    //       disabled: false,
    //     },
    //     {
    //       cols: 4,
    //       tipo: "numero",
    //       key: "km",
    //       valor: "",
    //       label: "Kilometros (*)",
    //       disabled: false,
    //     },
    //     {
    //       cols: 4,
    //       tipo: "numero",
    //       key: "codigo_sucursal",
    //       valor: "",
    //       label: "Codigo Sucursal",
    //       disabled: true,
    //     },
    //   ],
      configuracion_modal: {
        titulo: "Registrar Carga Petróleo",
        ancho: "xl",
        ruta: "/cargas_petroleo",
        tipo_ruta: "post",
        titulo_boton: "Crear",
        clase_boton: "btn-success",
      },
      configuracion_tabla: {
        titulo: "Listado de Cargas de Petróleo",
        titulo_boton: "Crear Carga Petróleo",
        clase_boton: "btn-primary",
        btn_nuevo: false,
      },
      pagina_actual: "",
      /* columns: [
              {label: 'Rut', field: 'rut'},
              {label: 'Nombre', field: 'nombre', headerClass: 'class-in-header second-class'}
          ], */
    }),
    mounted() {
      this.inicializar_tabla({
        columnas: [],
        lista: [],
        links: [],
        botones: [],
        botones_restringidos: [],
      });
      let storage = localStorage.getItem(this.path);
      if (storage) {
        storage = JSON.parse(storage);
        this.columnas.forEach((col) => {
          col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
        });
      }
      this.$emit("spinner", true);
      this.cargar_camiones();
    },
    methods: {
      refrescar() {
        localStorage.removeItem(this.path);
        this.columnas.forEach((c) => {
          if (
            [
              "string",
              "number",
              "select",
              "select-loadable",
              "select-loadable-dependiente",
              "datetime",
              "html",
              "html_select",
            ].includes(c.tipo)
          ) {
            c.busqueda = "";
          }
  
          if (["multiselect"].includes(c.tipo)) {
            c.busqueda = [];
          }
        });
        this.$emit("cargar");
      },
      async cargar_camiones() {
        await this.axios
          .get(
            `${this.api}/transportes?limit=99999999`,
            this.cabeceras_json
          )
          .then((res) => {
            this.$set(this.columnas[3], "opciones", res.data.data.data);
            //this.$set(this.inputs[2], "opciones", res.data.data.data);
            //console.log('opciones',res.data.data.data);
            //this.inputs[1].opciones = res.data.data.data;
            //this.cargar('');
            //this.cargar_empresas();
          })
          .catch((e) => {
            //alert(e);
          });
        //this.cargar_empresas();
        this.cargar('')
      },
      async cargar($event) {
        this.$emit("spinner", true);
        this.pagina_actual = `${this.api}/cargas_petroleo${$event}`;
        this.lista = [];
        await this.axios
          .get(`${this.api}/cargas_petroleo${$event}`, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            /* let config = {
                    columnas:this.columnas,
                    lista:this.lista,
                    links:this.links
                  } */
            this.inicializar_tabla({
              columnas: this.columnas,
              lista: this.lista,
              links: this.links,
              botones: this.botones,
            });
            //this.$emit("generar", this.columnas, this.lista);
            ////console.log('listado',res.data.data.data);
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
        this.$emit("spinner", false);
      },
      async cargar_url(url) {
        if (url) {
          this.$emit("spinner", true);
          this.pagina_actual = url;
          await this.axios
            .get(url, this.cabeceras_json)
            .then((res) => {
              this.lista = res.data.data.data;
              this.links = res.data.data.links;
              ////console.log('listado',res.data.data.data);
              this.setear_lista({ lista: this.lista, links: this.links });
              //$('#empresas').DataTable().draw();
            })
            .catch((e) => {
              //alert(e);
            });
          this.$emit("spinner", false);
        }
      },
      crear() {
        this.inputs[0].disabled = false;
        this.inputs[3].disabled = false;
        this.inputs[9].disabled = false;
  
        this.setear_inputs(this.inputs);
        this.restablecer_inputs();
        this.configuracion_modal.ruta = `/cargas_petroleo`;
        this.configuracion_modal.tipo_ruta = "post";
        this.configuracion_modal.titulo_boton = "Crear";
        this.configuracion_modal.clase_boton = "btn-success";
  
        this.$emit("abrir", { inputs: this.inputs });
      },
      editar(evento) {
        //console.log('evento',evento);
        let item = evento.item;
        this.inputs.forEach((i) => {
          //recorrido del objeto a editar
          Object.keys(item).forEach((key) => {
            let valor = item[key];
            if (i.key == key) {
              i.valor = valor;
            }
          });
        });
  
        this.setear_inputs(this.inputs);
        this.configuracion_modal.ruta = `/cargas_petroleo/${evento.item.id}`;
        this.configuracion_modal.tipo_ruta = "put";
        this.configuracion_modal.titulo_boton = "Actualizar";
        this.configuracion_modal.clase_boton = "btn-warning";
  
        this.$emit("abrir");
      },
      restablecer_inputs() {
        this.cargar_url(this.pagina_actual);
        this.inputs.forEach((i) => {
          i.valor = "";
        });
        this.setear_inputs(this.inputs);
      },
      ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
    },
    components: {
      "modal-crear-editar": ModalCrearEditar,
      tablita: Tabla,
    },
    computed: {
      ...mapState(["api", "cabeceras_json"]),
      query() {
        let string = "?";
        let and = "";
        let total = this.columnas.length - 1;
        this.columnas.forEach((c, index) => {
          if (index > 0 && string.length > 0) {
            and = "&";
          } else if (index == total) {
            and = "";
          }
  
          if (c.busqueda != "") {
            string += `${and}${c.key}=${c.busqueda}`;
          }
        });
        return string;
      },
  
      path() {
        return this.$router.currentRoute.path;
      },
    },
  };
  </script>
  <style>
  .form-control {
    height: calc(1em + 1.25rem + 5px);
  }
  </style>